import { useState } from "react";
import { History } from "lucide-react";

const LABELS = { marked_paid: "Marked paid", confirmed: "Confirmed", waived: "Fee waived", unconfirmed: "Confirmation undone", rejected: "Rejected", reminded: "Reminder sent", receipt_resent: "Confirmation re-sent" };
const TONES = { confirmed: "text-emerald-700", waived: "text-violet-700", unconfirmed: "text-amber-700", rejected: "text-red-600" };
const fmt = (s) => new Date(s).toLocaleString("en", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export function OrderHistory({ order }) {
  const [open, setOpen] = useState(false);
  const rows = order.history || [];
  return (
    <div className="w-full" data-testid={`order-history-${order.id}`}>
      <button onClick={() => setOpen(!open)} className="text-xs text-slate-500 hover:text-navy inline-flex items-center gap-1 transition-colors" data-testid={`order-history-toggle-${order.id}`}>
        <History className="w-3.5 h-3.5" /> {open ? "Hide history" : `History${rows.length ? ` (${rows.length})` : ""}`}
      </button>
      {open && (
        <ol className="mt-1.5 border-l-2 border-slate-100 pl-3 space-y-1 text-xs" data-testid={`order-history-list-${order.id}`}>
          <li className="text-slate-500"><b className="text-navy">Created</b> · {fmt(order.created_at)}</li>
          {rows.map((h, i) => (
            <li key={i} className="text-slate-500" data-testid={`order-history-row-${order.id}-${i}`}>
              <b className={TONES[h.action] || "text-navy"}>{LABELS[h.action] || h.action}</b> · {fmt(h.at)} · by {h.by || "—"}{h.role ? ` (${h.role})` : ""}{h.note ? <span className="text-slate-400"> — {h.note}</span> : null}
            </li>
          ))}
          {!rows.length && <li className="text-slate-400">No actions recorded yet (tracking started Oct 17, 2026).</li>}
        </ol>
      )}
    </div>
  );
}
